import { NoteIcon } from "components/Icons";

const STYLE_BUTTON_MENU =
  "flex space-x-3 hover:scale-105 cursor-pointer transition-all duration-300 first:text-yellow-500 block px-4 py-2 bg-gray-700 rounded-2xl font-semibold text-white";

const menuItems = [
  { key: "icons", label: "Iconos" },
  { key: "buttons", label: "Botones" },
  { key: "colors", label: "Colores" },
  { key: "alerts", label: "Alertas" },
  { key: "fields", label: "Fields" },
];

const Navbar = ({ handleClick }) => {
  return (
    <div className="px-4">
      <ul className="space-y-2 text-white">
        {menuItems.map((item, index) => (
          <li key={item.key} className="w-full">
            <a
              className={STYLE_BUTTON_MENU}
              onClick={() => handleClick(item.key)}
            >
              <NoteIcon className="w-5 h-5 fill-current" />
              <span>{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Navbar;
